export enum LocalStorageKeysEnum {
  onboardingShowed = 'onboardingShowed',
  phone = 'phone',
  userGuid = 'userGuid',
  lastOrderNumber = 'lastOrderNumber',
  lastOrderGuid = 'lastOrderGuid',
  lastOrderMealsList = 'lastOrderMealsList'
}
